"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
const path = (id) => `/event/${id.substring(6)}/team`;
function removeTeam({ token, team, event, }) {
    const data = {
        team,
    };
    return client_1.default.delete(path(event), {
        headers: {
            Authorization: token,
        },
        data,
    });
}
exports.default = removeTeam;
